import { createSelector } from 'reselect';

const stateAdminSelector = (state) => state.admin;

export const adminSelector = createSelector(
    [stateAdminSelector],
    (admin) => {
        return {...admin};
    }
);
